import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Cell,
} from "recharts";
import useGetUnverifiedInvoiceCount from "../../CarrierAgreementMgmt/VendorInvoice/InvoiceCapture/hooks/useGetUnverifiedInvoiceCount";
import useGetForReviewInvoiceCount from "../../CarrierAgreementMgmt/VendorInvoice/ForReview/hooks/useGetForReviewInvoiceCount";
import useGetApprovedInvoiceCount from "../../CarrierAgreementMgmt/VendorInvoice/SubmittedToAcumatica/hooks/useGetApprovedInvoiceCount";
import useGetCompletedInvoiceCount from "../../CarrierAgreementMgmt/VendorInvoice/Completed/hooks/useGetCompletedInvoiceCount";
import useGetVoidedInvoiceCount from "../../CarrierAgreementMgmt/VendorInvoice/Voided/hooks/useGetVoidedInvoiceCount";
import useGetAllVendorInvoiceCount from "../../CarrierAgreementMgmt/VendorInvoice/InvoiceCapture/hooks/useGetVendorInvoiceCount";
import useGetReconciliationCount from "modules/CarrierAgreementMgmt/VendorInvoice/Reconcilliation/hooks/useGetReconcilationCount";

const VendorInvoiceChart = () => {
  const { data: invoices } = useGetAllVendorInvoiceCount();
  const { data: forReview } = useGetForReviewInvoiceCount();
  const { data: unverified } = useGetUnverifiedInvoiceCount();

  const { data: approved } = useGetApprovedInvoiceCount();
  const { data: completed } = useGetCompletedInvoiceCount();
  const { data: voided } = useGetVoidedInvoiceCount();
  const { data: reconciliation } = useGetReconciliationCount();

  const colors = [
    "#0078D7",
    "#01579E",
    "#FE4EF7",
    "#CB227B",
    "#00C8FF",
    "#0B77BF",
  ];

  const invoiceData = [
    {
      Name: "For Review",
      Status: forReview,
    },
    {
      Name: "Unverified",
      Status: unverified,
    },

    {
      Name: "Reconciliation",
      Status: reconciliation,
    },
    {
      Name: "Submitted",
      Status: approved,
    },
    {
      Name: "Completed",
      Status: completed,
    },
    {
      Name: "Voided",
      Status: voided,
    },
  ];

  return (
    <div>
      <div className="grid grid-cols-2">
        <div className="grid sm:grid-cols-1">
          <h1 className="pb-2 text-sm text-tertiary font-semibold">
            Vendor Invoice Status
          </h1>
        </div>
        <div className="grid sm:grid-cols-1">
          <h4 className="text-right text-xs text-tertiary font-base">
            Total of <span className="text-base font-semibold">{invoices}</span>
          </h4>
        </div>
      </div>
      <div className="flex flex-auto justify-center pt-7">
        <ResponsiveContainer height={200}>
          <BarChart
            className="flex items-center"
            width={300}
            height={300}
            data={invoiceData}
            margin={{
              top: 5,
              right: 25,
              left: -13,
              bottom: 5,
            }}
            barSize={35}
          >
            <CartesianGrid strokeDasharray="2 2" />
            <XAxis dataKey="Name" fontSize={9} angle={-30} dy={10} />
            <YAxis fontSize={10} domain={[0, 50]} allowDataOverflow={true} />
            <Tooltip />
            <Bar dataKey="Status" fill="#8884d8">
              {invoiceData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors[index % 20]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default VendorInvoiceChart;
